export enum UserTypes {
  USER = 1,
  CHANNEL_PARTNER
}
